/**
 * 直播连接
 */
import React from 'react';

import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool';
let { Session, copy } = utils_tool;
let { WizComponent, WizRow, WizCol, WizTypography, WizTabs, Wizmessage, WizInput, WizQRCode, WizSpin, WizDivider } = component_tool;
let { WizContainer, WizReduxTemplate } = framework_tool;
const { Title, Text, Paragraph } = WizTypography
import { modelUtils } from "@/utils";
import '@/styles/components/live/index.less'


class LinkView extends WizContainer {

  componentName = 'linkView';

  constructor(props) {
    super(props);
    this.state = {
      tabKey: 'lecturer' //tab标签
    };
  }


  _componentDidMount() {
    if (this.props.id) {
      this.doAction({
        path: 'interactLive/getLiveRoomInfo',
        payload: {
          key: "getLiveRoomInfo_" + this.props.id,
          apiParams: {
            id: this.props.id
          }
        }
      });
    }
  }


  _copy = (text) => {
    if (copy && copy(text)) {
      Wizmessage.success('复制成功!', 1)
    } else {
      Wizmessage.error('复制失败,请手动复制!', 1)
    }
  }

  /**复制点击按钮 */
  _copyView(value) {
    return <a onClick={() => this._copy(value)} className='live-a'>复制</a>
  }

  /**下载点击按钮 href={base64} */
  _downloadView(id, value, fileName, offset = 4, isImg) {
    let clickFun = () => this.changeCanvasToPic(id + 'qrCode', id + 'download');
    if (isImg) {
      clickFun = () => this.changeCanvasToPic2(id + 'qrCode', id + 'download');
    }
    // let encode = encodeURI(value);
    // let base64 = btoa(encode);
    return <WizCol span={5} offset={offset} className='live-download'><Paragraph> <a id={id + 'download'} onClick={clickFun} download={fileName} className="live-download-a">下载</a></Paragraph></WizCol>
  }

  /**打开点击按钮 */
  _openView(value) {
    return <a onClick={() => window.open(value, '_blank')} className='live-a'>打开</a>
  }


  /**连接行  <a style={{ color: 'blue' }} href={value} target={'_blank'}>{showValue}</a> */
  _linkRow(key, value) {
    return (
      <WizRow className='live-row-item'>
        <WizCol className='live-col-item-one' span={4}><Paragraph >{key}:</Paragraph></WizCol>
        <WizCol span={13} offset={1}><Paragraph> <WizInput disabled={true} value={value} />  </Paragraph></WizCol>
        <WizCol span={5} offset={1} className='live-col-item-two'><Paragraph>{this._copyView(value)}<WizDivider type="vertical" />{this._openView(value)}</Paragraph></WizCol>
      </WizRow>
    )
  }

  /**房间号 */
  _copyRow(roomNumber, code) {
    return (
      <WizRow className='live-row-item'>
        <WizCol className='live-col-item' span={4}><Paragraph>房间号:</Paragraph></WizCol>
        <WizCol span={4} offset={1}><Paragraph>{roomNumber}</Paragraph></WizCol>
        <WizCol span={2} ><Paragraph>{this._copyView(roomNumber)}</Paragraph></WizCol>
        <WizCol className='live-col-item' span={3} ><Paragraph>直播口令:</Paragraph></WizCol>
        <WizCol span={4} offset={1}><Paragraph>{code}</Paragraph></WizCol>
        <WizCol span={2} ><Paragraph>{this._copyView(code)}</Paragraph></WizCol>
      </WizRow>
    )
  }

  _imageView(id, value) {
    let url = constants.files.sys_img_non_existent;
    if (value) {
      url = value;
    }
    return (
      <div className="live-image" >
        <WizQRCode
          id={id + 'qrCode'}
          size={140}  // 二维码的大小
          value={value}
        // fgColor="#000000" // 二维码的颜色
        // style={{ margin: 'auto' }}
        // imageSettings={{ // 二维码中间的logo图片
        //     src: 'logoUrl',
        //     height: 100,
        //     width: 100,
        //     excavate: true, // 中间图片所在的位置是否镂空
        //  }}
        />
      </div>
    )
  }

  _qrCodeView(id, value) {
    return (
      <div className="live-image">
        <img id={id + "qrCode"} height={140} width={140} src={value} fallback={constants.files.sys_img_non_existent} />
      </div>
    )
  }

  /**图片下载 */
  _imageDownloadRow(imageUrl1, imageTitle1, imageUrl2, imageTitle2) {
    let theOffset = 0;
    if (imageUrl1 && imageUrl2) {
      theOffset = 1;
    }
    return (
      <>
        <WizRow className='live-row-item'>
          {imageUrl1 && imageTitle1 ?
            <>
              <WizCol className='live-col-item' span={4}><Paragraph>{imageTitle1}:</Paragraph></WizCol>
              <WizCol span={5}><Paragraph>{this._imageView('image1', imageUrl1)} </Paragraph></WizCol>
            </>
            : null
          }
          {imageUrl2 && imageTitle2 ?
            <>
              <WizCol className='live-col-item' span={4} offset={theOffset} ><Paragraph>{imageTitle2}:</Paragraph></WizCol>
              <WizCol span={5}><Paragraph>{this._qrCodeView('image2', imageUrl2)} </Paragraph></WizCol>
            </>
            : null
          }
        </WizRow>
        <WizRow className='live-row-item'>
          {imageUrl1 && imageTitle1 ? this._downloadView('image1', imageUrl1, 'code.jpg') : null}
          {imageUrl2 && imageTitle2 ? this._downloadView('image2', imageUrl2, 'weChatCode.jpg', theOffset + 4, true) : null}
        </WizRow>
      </>
    )
  }

  changeCanvasToPic(id, aId) {
    const canvasImg = document.getElementById(id); // 获取canvas类型的二维码
    const img = new Image();
    img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
    const downLink = document.getElementById(aId);
    downLink.href = img.src;
    downLink.download = '二维码'; // 图片name
  };

  changeCanvasToPic2(id, aId) {
    const img = document.getElementById(id);
    const downLink = document.getElementById(aId);
    downLink.href = img.src;
    downLink.download = '小程序二维码.jpg'; // 不知道为什么这个不能下载后直接是.jpg 没找到对应属性
  };

  _onChange = (key) => {
    if (this.state.tabKey !== key) {
      this.setState({
        tabKey: key,
        time: new Date().getTime()
      });
    }
  }

  showLinkView() {
    let { type, getLiveRoomInfo } = this.props;

    let roomNumber;
    let code;
    let playUrl;
    let studentUrl;
    let weChatCodeUrl;
    if (getLiveRoomInfo && getLiveRoomInfo.data) {
      roomNumber = getLiveRoomInfo.data.roomSn;
      code = getLiveRoomInfo.data.anchorKey;
      playUrl = getLiveRoomInfo.data.lecturerEpUrl;
      studentUrl = getLiveRoomInfo.data.audienceEpUrl;
      if (getLiveRoomInfo.data.qrcode) {
        weChatCodeUrl = 'data:image/jpg;base64,' + getLiveRoomInfo.data.qrcode;
      }
    }
    if (type === 2 || type === 1) {
      return (
        <WizTabs animated={false} defaultActiveKey="detailed" onChange={this._onChange.bind(this)}>
          {/* <WizTabs.TabPane tab="讲师" key="lecturer">
            {this._linkRow("网页开播链接", playUrl)}
            {this._copyRow(roomNumber, code)}
          </WizTabs.TabPane> */}
          <WizTabs.TabPane tab={'学员'} key="student">
            {this._linkRow("观看链接", studentUrl)}
            {this._imageDownloadRow(studentUrl, "扫码观看", weChatCodeUrl, '小程序观看')}
          </WizTabs.TabPane>
        </WizTabs>
      )
    } else if (type === 3) {
      return (<>
        {this._linkRow("观看链接", studentUrl)}
        {this._imageDownloadRow(studentUrl, "扫码观看")}
      </>)
    }
  }

  _render() {
    return <WizSpin tip={''} spinning={this.props.interactLiveLoading}> {this.showLinkView()} </WizSpin>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive } = state;
  const getLiveRoomInfo = modelUtils.getModelEntity(interactLive, "getLiveRoomInfo_" + ownProps.id);
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    getLiveRoomInfo,
    ...load
  }
};

export default connect(mapStateToProps)(LinkView);
